(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-blend-hero"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. The guard keeps a save
   from registering a second set of document listeners. */
if (!window.__bwBlendHeroBound) {
  window.__bwBlendHeroBound = true;
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function current() {
      /* Three states. Collapsing anything that was not Restore to Move was
         right while the site had two blends; the blends hero can select The
         Daily System now, and with this reading it as Move the System label
         stayed cream on a cream thumb and Move turned ink on an ink ground —
         both invisible. */
      var v = document.documentElement.getAttribute('data-bw-blend');
      return (v === 'restore' || v === 'system') ? v : 'move';
    }

    /* Everything below is enhancement only. CSS already renders the correct
       blend; this adds the in-flight shadow drop and syncs aria-pressed. */
    function flourish() {
      document.querySelectorAll('[data-bw-blend-hero]').forEach(function (root) {
        var rail = root.querySelector('[data-bw-packets]');
        if (rail && !reduce.matches) {
          rail.classList.add('is-swapping');
          clearTimeout(rail._bwTimer);
          var ms = parseInt(getComputedStyle(root).getPropertyValue('--bwbh-swap-ms'), 10) || 620;
          rail._bwTimer = setTimeout(function () { rail.classList.remove('is-swapping'); }, ms);
        }
        root.querySelectorAll('[data-bw-blend-set]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.bwBlendSet === current()));
        });
      });
    }

    /* Transitions are enabled a frame after paint so the initial park does not
       animate in from off-screen on load. */
    function ready() {
      document.querySelectorAll('[data-bw-blend-hero] [data-bw-packets]').forEach(function (rail) {
        requestAnimationFrame(function () { rail.classList.add('is-ready'); });
      });
      document.querySelectorAll('[data-bw-blend-hero]').forEach(function (root) {
        if (root.dataset.bwTilt === '1' || reduce.matches) return;
        root.dataset.bwTilt = '1';
        var stage = root.querySelector('[data-bw-stage]');
        if (!stage) return;

        var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

        stage.addEventListener('mouseenter', function () {
          root.style.setProperty('--bwbh-tilt', (Math.random() * 7 - 3.5).toFixed(2) + 'deg');
        });

        /* Touch: tap to enlarge, tap again to release. CSS keeps :hover away
           from coarse pointers, so this class is the only thing holding the
           pose and the second tap genuinely clears it. The tilt is re-rolled on
           the way in only, matching what mouseenter does. */
        stage.addEventListener('click', function () {
          if (fine.matches) return;
          if (stage.classList.toggle('is-tapped')) {
            root.style.setProperty('--bwbh-tilt', (Math.random() * 7 - 3.5).toFixed(2) + 'deg');
          }
        });
      });
      document.querySelectorAll('[data-bw-blend-hero] [data-bw-blend-set]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.bwBlendSet === current()));
      });
    }

    document.addEventListener('bw:blendchange', flourish);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bw-blend-hero] [data-bw-blend-set]');
      if (!btn) return;
      var v = btn.dataset.bwBlendSet;
      if (document.documentElement.getAttribute('data-bw-blend') === v) return;
      document.documentElement.setAttribute('data-bw-blend', v);
      try { localStorage.setItem('bw-blend', v); } catch (err) {}
      document.dispatchEvent(new CustomEvent('bw:blendchange', { detail: { blend: v } }));
    });

    /* Editor: re-arm after a re-render, and switch to the blend whose block
       the merchant just selected so they can see what they are editing. */
    document.addEventListener('shopify:section:load', ready);

    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      if (!el || !el.closest || !el.closest('[data-bw-blend-hero]')) return;
      var key = el.getAttribute('data-b');
      if (!key) return;
      if (document.documentElement.getAttribute('data-bw-blend') === key) return;

      /* localStorage MUST be written here, not just the attribute.

         The header's inline script runs on every render and sets the
         attribute from localStorage. Setting only the attribute meant the
         header reset it on the next render, the editor re-fired select, this
         handler set it again — an unbounded ping-pong between two scripts,
         triggered precisely by selecting the block for the blend that is not
         currently active. */
      try { localStorage.setItem('bw-blend', key); } catch (err) {}
      document.documentElement.setAttribute('data-bw-blend', key);
      document.dispatchEvent(new CustomEvent('bw:blendchange', { detail: { blend: key } }));
    });

    if (document.readyState !== 'loading') ready();
    else document.addEventListener('DOMContentLoaded', ready);
  })();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-blend-split"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. Without this guard
   every save registers another full set of document listeners, and after a
   handful of saves a single click runs dozens of stale handlers holding
   detached nodes — which is what locks the editor tab up. */
if (!window.__bwSplitBound) {
  window.__bwSplitBound = true;

(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bind(panel) {
    /* Randomised tilt: the packshot leans a slightly different way each time,
       so repeated hovers do not feel like a canned loop. Same fixed +/-3.5deg
       spread the blend hero rolls for its packet.

       The range is a constant, NOT read back off --bwp-tilt. Seeding each roll
       from the previous one — which is what this did before — shrinks the
       magnitude every hover, because each result is drawn from a band narrower
       than the value it was seeded with. After a handful of hovers the tilt had
       decayed to nothing and the effect looked broken. */
    if (panel.dataset.bwRandomTilt === 'true' && !reduce.matches) {
      panel.addEventListener('mouseenter', function () {
        panel.style.setProperty('--bwp-tilt', (Math.random() * 7 - 3.5).toFixed(2) + 'deg');
      });
    }

    /* Pointer-tracked lean. Pointer-fine only: on a touchscreen there is no
       hover state to track and the sachet would simply jump on tap. */
    if (panel.dataset.bwPointerTilt === 'true' && !reduce.matches &&
        window.matchMedia('(pointer: fine)').matches) {
      var img = panel.querySelector('.bw-panel__img');
      var frame = 0;
      var maxTilt = parseFloat(getComputedStyle(panel).getPropertyValue('--bwp-tilt-max')) || 9;

      panel.addEventListener('pointermove', function (e) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = 0;
          var r = panel.getBoundingClientRect();
          /* -1..1 from panel centre on each axis */
          var nx = (e.clientX - r.left) / r.width * 2 - 1;
          var ny = (e.clientY - r.top) / r.height * 2 - 1;
          panel.classList.add('is-tracking');
          panel.style.setProperty('--bwp-ry', (nx * maxTilt).toFixed(2) + 'deg');
          panel.style.setProperty('--bwp-rx', (-ny * maxTilt).toFixed(2) + 'deg');
        });
      });

      panel.addEventListener('pointerleave', function () {
        panel.classList.remove('is-tracking');
        panel.style.setProperty('--bwp-ry', '0deg');
        panel.style.setProperty('--bwp-rx', '0deg');
      });
    }

    /* Clicking a panel can also set the site blend, so arriving on the linked
       page finds the palette already switched rather than flipping after. */
    var blend = panel.dataset.bwSetBlend;
    if (blend) {
      panel.addEventListener('click', function () {
        document.documentElement.setAttribute('data-bw-blend', blend);
        try { localStorage.setItem('bw-blend', blend); } catch (e) {}
        document.dispatchEvent(new CustomEvent('bw:blendchange', { detail: { blend: blend } }));
      });
    }
  }

  function init() { document.querySelectorAll('[data-bw-panel]').forEach(bind); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bw-panel]').forEach(bind);
  });
})();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-build-box"] && !Shopify.designMode) return;
  try {
    
/*
  BW · RESERVE BAND

  Two radio groups and a summary bar. State is exactly two values — which size
  and which blend — and everything on screen is a function of the pair.

  THIS FILE DOES NO ARITHMETIC ON MONEY.

  Every figure the toggle can display was computed by Liquid and parked on the
  size radio as a finished string: dollars, cents, formatted total. The script
  copies strings from the checked size onto the cards. That is not fastidious-
  ness, it is the only way the server-rendered price and the toggled price can
  be guaranteed to agree — two implementations of the same rounding rule agree
  until the first edge case, and a per-serving figure that disagrees with
  itself by a cent between page load and first click is the sort of thing
  nobody reports and everybody notices.

  It also means no currency formatting here, so the store's locale and
  money_format stay the single source of truth.
*/
(function () {
  'use strict';

  function boot(root) {
    if (!root || root.dataset.bbBound === '1') return;
    root.dataset.bbBound = '1';

    var sizes  = [].slice.call(root.querySelectorAll('[data-bb-size]'));
    var blends = [].slice.call(root.querySelectorAll('[data-bb-blend]'));
    var slots  = [].slice.call(root.querySelectorAll('[data-bb-slot]'));
    var badge  = root.querySelector('[data-bb-badge]');
    var valueEl   = root.querySelector('[data-bb-value]');

    /* Reduced motion is read once. Everything below is decoration on a layout
       that is already correct, so the flag simply skips it rather than
       branching into a second, quieter set of effects. */
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Nothing animates until the first paint has been and gone. Otherwise the
       whole card block ticks the instant the page loads, which is the fade-in
       this section is specifically not allowed to have. */
    var primed = false;
    var valueRef  = root.querySelector('[data-bb-value-ref]');
    var valueSave = root.querySelector('[data-bb-value-save]');
    var srLive    = root.querySelector('[data-bb-sr]');
    var ctaLbl = root.querySelector('[data-bb-cta-label]');
    var sumD   = root.querySelector('[data-bb-sum-perd]');
    var sumC   = root.querySelector('[data-bb-sum-perc]');
    var line1  = root.querySelector('[data-bb-line-1]');
    var upsell = root.querySelector('[data-bb-upsell]');
    var upsellText = root.querySelector('[data-bb-upsell-text]');
    var upsellShort = root.querySelector('[data-bb-upsell-short]');
    var swatch = root.querySelector('[data-bb-swatch]');

    if (!blends.length) return;

    function checkedSize() {
      for (var i = 0; i < sizes.length; i++) if (sizes[i].checked) return sizes[i];
      return sizes[0] || null;
    }

    function checkedBlend() {
      for (var i = 0; i < blends.length; i++) if (blends[i].checked) return blends[i];
      blends[0].checked = true;
      return blends[0];
    }

    /* A blend card reads the "single" figures; the system card reads its own.
       Move and Restore are the same price by definition — one blend, one
       box — so they share a row rather than each carrying a duplicate. */
    function figuresFor(sizeEl, key) {
      var d = sizeEl.dataset;
      var isSystem = key === 'system';
      return {
        on:    (isSystem ? d.systemOn : d.singleOn) === 'true',
        d:      isSystem ? d.systemD : d.singleD,
        c:      isSystem ? d.systemC : d.singleC,
        total:  isSystem ? d.systemTotal : d.singleTotal,
        servings: isSystem ? d.systemServ : d.singleServ,
        days:     isSystem ? d.systemDays : d.singleDays,
        /* The chip's own ladder, per family. The Daily System is not on the
           same price curve as a single blend, so a chip that quotes the single
           figure while a System card is selected is quoting the wrong card. */
        savePct:  isSystem ? d.savePctSys : d.savePct,
        saveOn:  (isSystem ? d.saveOnSys : d.saveOn) === 'true',
        isBest:  (isSystem ? d.bestSys : d.best) === 'true'
      };
    }

    /* Every element whose text this repaint can change. Collected fresh each
       time rather than cached: a size with no price for a card hides the whole
       slot, so the list is not the same from one repaint to the next. */
    function figureEls() {
      return [].slice.call(root.querySelectorAll(
        '.bw-bb__per, .bw-bb__sub, .bw-bb__supply, .bw-bb__value, .bw-bb__sizeprice'
      ));
    }

    /* Runs the repaint, then marks whichever figures actually came out
       different. Comparing text is what keeps this honest — pressing the size
       that is already selected changes nothing and animates nothing. */
    function withTick(fn) {
      if (still || !primed) { fn(); return; }
      var els = figureEls();
      var before = els.map(function (e) { return e.textContent; });
      fn();
      els.forEach(function (e, i) {
        if (e.textContent === before[i]) return;
        e.classList.remove('is-tick');
        /* Reading offsetWidth forces the style recalculation that lets the
           same animation start again on an element that just finished it. */
        void e.offsetWidth;
        e.classList.add('is-tick');
      });
    }

    root.addEventListener('animationend', function (ev) {
      if (ev.animationName === 'bw-bb-tick') ev.target.classList.remove('is-tick');
      if (ev.animationName === 'bw-bb-pick') ev.target.classList.remove('is-picked');
    });

    function paint() {
      var sizeEl = checkedSize();
      if (!sizeEl) return;
      var sd = sizeEl.dataset;

      /* Cards first, so the blend fallback below is deciding against slots
         whose hidden state is already current for this size. */
      slots.forEach(function (slot) {
        var key = slot.dataset.blend;
        var f = figuresFor(sizeEl, key);
        var card = slot.querySelector('.bw-bb__card');
        if (!card) return;

        /* A size with no price for this card hides the card rather than
           printing a zero. A missing price is a gap in the data, and $0.00 is
           an offer. */
        slot.hidden = !f.on;

        /* Nothing to repaint inside a card any more — the figures moved to
           the bar. The loop stays for the one thing that is still per-card:
           whether this blend is offered at the selected size at all. */
      });

      if (badge) badge.hidden = sd.badge !== 'true';

      /* If the selected blend has no price at this size, fall back to the
         first card that does rather than leaving a hidden card selected and
         a reserve button pointing at nothing. */
      var b = checkedBlend();
      if (b.closest('[data-bb-slot]').hidden) {
        for (var i = 0; i < blends.length; i++) {
          if (!blends[i].closest('[data-bb-slot]').hidden) { blends[i].checked = true; break; }
        }
        b = checkedBlend();
      }

      var f = figuresFor(sizeEl, b.dataset.blend);
      root.setAttribute('data-blend', b.dataset.blend);

      /* THE CHIPS FOLLOW THE CARD.

         Every chip carries both families' strings; this picks the pair that
         matches the selected blend and writes them. Liquid has already
         printed the correct pair for the default blend, so a visitor with no
         scripting sees a coherent row rather than a blank one. */
      /* The ghost and the stick counts. Both are the selection said again in
         a different register — one enormous and behind everything, one small
         and factual on the card — so both come off the figures the rest of
         the repaint is already using. */
      var ghost = root.querySelector('[data-bb-ghost]');
      if (ghost) ghost.textContent = b.dataset.ghost || '';

      slots.forEach(function (slot) {
        var sticks = slot.querySelector('[data-bb-sticks]');
        if (!sticks) return;
        var sf = figuresFor(sizeEl, slot.dataset.blend);
        sticks.textContent = sf.servings || '';
      });

      var bKey = b.dataset.blend;
      sizes.forEach(function (sz) {
        var cf = figuresFor(sz, bKey);
        var cp = sz.nextElementSibling && sz.nextElementSibling.querySelector('[data-bb-chip-price]');
        var cs = sz.nextElementSibling && sz.nextElementSibling.querySelector('[data-bb-chip-save]');
        if (cp) {
          cp.hidden = !cf.on;
          cp.textContent = cf.on
            ? (root.dataset.currencySymbol || '$') + cf.d + '.' + cf.c
            : '';
        }
        if (cs) {
          cs.hidden = !cf.saveOn;
          cs.textContent = (root.dataset.saveWord || 'Save') + ' ' + cf.savePct + '%';
        }

        /* The ranking is its own element now, so it is shown rather than
           spliced into a sentence. */
        var cbest = sz.nextElementSibling && sz.nextElementSibling.querySelector('[data-bb-chip-best]');
        if (cbest) cbest.hidden = !cf.isBest;
      });


      if (sumD) sumD.textContent = f.d || '';
      if (sumC) sumC.textContent = f.c || '';
      if (line1 && f.on) {
        line1.textContent = [f.total, f.servings + ' ' + (root.dataset.servingsWord || 'servings'),
          f.days ? f.days + (root.dataset.supplySuffix || '-day supply') : null]
          .filter(Boolean).join(' · ');
      }
      /* THE BUNDLE LINE.

         On the card this was rendered inside the system branch, so it could
         assume its own presence meant "system". There is one bar for all
         three now, so the condition is explicit: the selected blend has to be
         the system AND the size has to have a saving worth printing.

         All three strings come off the size chip, rendered there by Liquid.
         The script moves strings and never does arithmetic, so a currency, a
         locale or a rounding rule is never decided here. */
      if (valueEl) {
        var vOn = b.dataset.blend === 'system' && sd.sysSaveOn === 'true';
        valueEl.hidden = !vOn;
        if (vOn) {
          if (valueRef)  valueRef.textContent  = sd.sysRef || '';
          if (valueSave) valueSave.textContent = (root.dataset.bundlePrefix || 'Save') + ' ' + (sd.sysSaveAmt || '');
        }
      }

      /* One live region for the band, announcing the figure as a sentence.
         Without it a screen reader hears "2" and "15" as two unrelated string
         changes and never learns what moved. It was one per card; with the
         money in a single place it is one, which is also less to hear. */
      if (srLive && f.on) {
        srLive.textContent = f.d + ' point ' + f.c + ' ' +
          (root.dataset.perServingLabel || 'per serving') + ', ' +
          (b.dataset.cta || '');
      }

      /* The label is no longer rewritten per blend. The button sits beside a
         swatch that carries the blend and a detail line that names the pack,
         so it says one word and keeps saying it — which also retires the
         boot-time width measurement that existed only because the three
         labels were different lengths. */

      /* The CTA label is the widest thing in the bar and it changes with the
         blend, so the bar can change height on a narrow screen where it
         wraps. The page reserves that height as padding, so it has to be
         re-read here and not only on resize. */
      measureBar();

      /* The swatch is the bar naming the choice, not just the price. Set from
         the card key rather than read off the card, so it is correct before
         any of the card CSS has resolved. */
      if (swatch) swatch.setAttribute("data-blend", b.dataset.blend);

      /* THE UPSELL.

         Built from the best chip's own figures so it can never quote a
         number the toggle does not agree with, and hidden outright when the
         best size is already the selected one — a nudge toward where you
         already are reads as a bug. */
      if (upsell && upsellText) {
        var best = null;
        var bestKey = (root.dataset.blend === 'system') ? 'bestSys' : 'best';
        for (var j = 0; j < sizes.length; j++) if (sizes[j].dataset[bestKey] === "true") best = sizes[j];
        var show = !!best && best !== sizeEl;
        upsell.hidden = !show;
        if (show) {
          /* The figures come from the same family the button is standing in
             front of, or the bar offers a saving on a card nobody selected. */
          var bf = figuresFor(best, b.dataset.blend);
          upsellText.textContent =
            (root.dataset.upsellPrefix || "Go") + " " + bf.servings + " " +
            (root.dataset.servingsWord || "servings") + " → " +
            (root.dataset.currencySymbol || "$") + bf.d + "." + bf.c +
            "/" + (root.dataset.perUnitShort || "serving") + " · " +
            (root.dataset.saveWord || "Save") + " " + bf.savePct + "%";
          if (upsellShort) {
            /* The long line does not fit a 390px bar beside a price. The short
               one keeps the two facts that change the decision — how much
               bigger, and how much cheaper — and drops the per-serving figure,
               which the chip above is already showing. */
            upsellShort.textContent =
              (root.dataset.upsellPrefix || "Go") + " " + bf.servings + " · " +
              (root.dataset.saveWord || "Save") + " " + bf.savePct + "%";
          }
          upsell.dataset.target = best.value;
        }
      }

      /* Handed to assets/bw-signup.js, which posts it to Klaviyo. Written on
         every repaint rather than read at submit time so the dialog can never
         describe a state the visitor has since changed. */
      var form = root.querySelector('[data-bw-signup]');
      if (form) {
        form.dataset.bwBlend = b.dataset.blend;
        /* size_intent is the step on the toggle — 10, 30, 60 — and it means
           servings PER BLEND, so on the Daily System it is half the sticks in
           the box. Both numbers go, because segmenting on "chose the 30" and
           segmenting on "reserved sixty servings" are different questions and
           deriving either from the other needs the blend as well. */
        form.dataset.bwProps = JSON.stringify({
          reserve_blend: b.dataset.blend,
          reserve_size_intent: parseInt(sd.servings, 10),
          reserve_servings_total: parseInt(f.servings, 10),
          reserve_price: f.total || '',
          reserve_source: root.dataset.reserveSource || 'shop'
        });
      }

      var tagField = root.querySelector('[data-bb-tags]');
      if (tagField) {
        tagField.value = [root.dataset.signupTag || 'waitlist', 'blend-' + b.dataset.blend, 'size-' + sd.servings].join(', ');
      }

      var summary = root.querySelector('[data-bb-reserve-summary]');
      if (summary && f.on) {
        summary.textContent = [b.dataset.cta, f.total, f.servings + ' ' + (root.dataset.servingsWord || 'servings')]
          .filter(Boolean).join(' · ');
      }
    }

    if (upsell) {
      upsell.addEventListener('click', function () {
        var target = upsell.dataset.target;
        for (var i = 0; i < sizes.length; i++) {
          if (sizes[i].value === target) {
            sizes[i].checked = true;
            withTick(paint);
            break;
          }
        }
      });
    }

    /* ---- when the fixed bar is allowed to be on screen -----------------

       Three independent reasons to hide it, tracked separately and combined,
       because a single boolean would let whichever check ran last overrule
       the others.

         seen      the card grid has been reached. Before that the bar would
                   be advertising a price for a row nobody has looked at.
         modal     the reserve dialog is open. The bar sits under it and its
                   CTA opens the very dialog already on screen.
         footer    the footer signup is in view. Two email captures competing
                   for the same screen is a choice nobody should have to make.

       It measures its own height into a custom property, which the page
       wrapper turns into bottom padding — set once and left alone, including
       while the bar is hidden, so nothing reflows as it comes and goes. */
    var bar = root.querySelector('[data-bb-summary]');
    var state = { seen: false, modal: false, footer: false };

    function applyBar() {
      if (!bar) return;
      var show = state.seen && !state.modal && !state.footer;
      root.classList.toggle('is-bar-out', !show);
    }

    function measureBar() {
      if (!bar) return;
      /* Height plus whatever it is floating above, measured rather than
         assumed: the bar sits flush to the bottom on a phone and 18px clear
         of it on a desktop, and the page has to reserve both. */
      var r = bar.getBoundingClientRect();
      var gap = Math.max(0, Math.round(window.innerHeight - r.bottom));

      /* The scroll container's own gutter, so the bar can sit on the same
         column as the cards instead of 10px past them on the right. */
      var sc = root.closest('.page-wrapper') || document.scrollingElement || document.documentElement;
      var sbw = Math.max(0, Math.round(sc.offsetWidth - sc.clientWidth));
      document.documentElement.style.setProperty('--bwbb-sbw', sbw + 'px');
      document.documentElement.style.setProperty('--bwbb-barh', (Math.round(r.height) + gap) + 'px');
    }

    if (bar && typeof IntersectionObserver === 'function') {
      var grid = root.querySelector('.bw-bb__cards');
      if (grid) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            /* Latching, not toggling: once the grid has been reached the bar
               stays available for the rest of the page, which is what "at or
               below that point" means. Scrolling back up past it is not a
               reason to take the CTA away. */
            if (en.isIntersecting) { state.seen = true; applyBar(); }
          });
        }, { threshold: 0.15 }).observe(grid);
      }

      var footerForm = document.querySelector('.bw-footer [data-bw-signup], .bw-footer__signup-form');
      if (footerForm) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { state.footer = en.isIntersecting; applyBar(); });
        }, { threshold: 0.2 }).observe(footerForm);
      }
    } else if (bar) {
      /* No IntersectionObserver: show it rather than never showing it. */
      state.seen = true;
    }

    /* The dialog has no open/close event pair that fires for showModal, so the
       attribute itself is the signal. */
    var dlg = root.querySelector('[data-bw-lead]');
    if (dlg && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        state.modal = dlg.hasAttribute('open');
        applyBar();
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }

    applyBar();
    measureBar();
    window.addEventListener('resize', measureBar);

    sizes.forEach(function (el) {
      el.addEventListener('change', function () { withTick(paint); });
    });

    blends.forEach(function (el) {
      el.addEventListener('change', function () {
        withTick(paint);

        /* The card that was just chosen gives a little under the press. On the
           card rather than the slot, so it composes with the slot's entrance
           and with the hover tilt without any of the three being told about
           the others. */
        if (still) return;
        var card = el.nextElementSibling;
        if (!card) return;
        card.classList.remove('is-picked');
        void card.offsetWidth;
        card.classList.add('is-picked');
      });
    });

    paint();
    primed = true;

    /* ---- dealing the cards in ------------------------------------------

       The section is exempt from bw-reveal because a pricing grid cannot be
       blank while a script decides how to animate it, and that exemption is
       the right one. It does not mean the band has to be inert.

       This is the same trigger the reveal script uses and none of its risk:
       the class it adds only ever starts an animation whose end state is the
       layout already on screen, so a visitor with no scripting, no
       IntersectionObserver or reduced motion on gets the finished band and
       misses nothing but the movement.

       Latching, and it disconnects itself: the cards are dealt once. */
    if (!still && root.classList.contains('bw-bb--deal') &&
        typeof IntersectionObserver === 'function') {
      var dealer = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          root.classList.add('is-dealt');
          dealer.disconnect();
        });
      }, { threshold: 0.12 });
      dealer.observe(root);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bw-build-box]').forEach(boot);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-header"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. Without this guard
   every save registers another full set of document listeners, and after a
   handful of saves a single click runs dozens of stale handlers holding
   detached nodes — which is what locks the editor tab up. */
if (!window.__bwHeaderBound) {
  window.__bwHeaderBound = true;

(function () {
  var KEY = 'bw-blend';

  /* ---- blend switching ---------------------------------------------- */
  function current() {
    /* Three states. Collapsing anything that was not Restore to Move was
         right while the site had two blends; the blends hero can select The
         Daily System now, and with this reading it as Move the System label
         stayed cream on a cream thumb and Move turned ink on an ink ground —
         both invisible. */
      var v = document.documentElement.getAttribute('data-bw-blend');
      return (v === 'restore' || v === 'system') ? v : 'move';
  }

  function sync() {
    var v = current();
    document.querySelectorAll('[data-bw-blend-set]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.dataset.bwBlendSet === v));
    });
  }

  function setBlend(v) {
    document.documentElement.setAttribute('data-bw-blend', v);
    try { localStorage.setItem(KEY, v); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('bw:blendchange', { detail: { blend: v } }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bw-blend-set]');
    if (btn) setBlend(btn.dataset.bwBlendSet);
  });

  /* The switcher is not the only thing that sets the blend. A panel in
     bw-blend-split sets it on click, and the blend choice in a lead form sets
     it on change — both correctly, both by dispatching this event. Without
     listening for it the pressed state here goes stale the moment anything
     else moves the site, and the header ends up claiming Move while the whole
     page is painted Restore. sync() is idempotent, so setBlend calling it
     directly and this handler calling it again costs nothing. */
  document.addEventListener('bw:blendchange', sync);

  /* ---- mobile drawer ------------------------------------------------- */
  function bindDrawer(header) {
    var drawer = header.querySelector('[data-bw-drawer]');
    var opener = header.querySelector('[data-bw-drawer-open]');
    if (!drawer || !opener) return;

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      drawer.removeAttribute('inert');
      /* Force a frame so the transform transition runs from its start value
         rather than being collapsed with the display change. */
      requestAnimationFrame(function () {
        /* Opening the menu while the header is tucked away would open it
           inside a translated ancestor, which reparents the fixed overlay. */
        var stickyGroup = document.getElementById('header-group');
        if (stickyGroup) stickyGroup.classList.remove('is-headroom-hidden');
        drawer.classList.add('is-open');
        opener.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var first = drawer.querySelector('a, button:not([tabindex="-1"])');
        if (first) first.focus();
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      drawer.setAttribute('inert', '');
      var panel = drawer.querySelector('.bw-drawer__panel');
      var done = function () { drawer.hidden = true; };
      if (panel) panel.addEventListener('transitionend', done, { once: true });
      else done();
      if (lastFocus) lastFocus.focus();
    }

    opener.addEventListener('click', open);
    drawer.querySelectorAll('[data-bw-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---- floating switcher --------------------------------------------- */
  /* Above 990px base.css makes .page-wrapper the scroller (height:100dvh;
     overflow-y:auto) and the window never scrolls, so a scroll listener on
     window would fire on mobile only. IntersectionObserver against the
     implicit root is clipped by every scrolling ancestor, so one observer
     covers both cases — and it costs nothing per frame. */
  var floatObservers = [];

  function bindFloat() {
    floatObservers.forEach(function (o) { o.disconnect(); });
    floatObservers = [];

    /* Every piece of floating furniture on the page, not just the blend pill.
       The home page's reserve button (snippets/bw-float-cta.liquid) arrives
       the same way and on the same terms, so it shares this rather than
       carrying a second observer that does the same job a frame apart. */
    document.querySelectorAll('[data-bw-float-panel]').forEach(bindOnePanel);
  }

  function bindOnePanel(panel) {

    // What the pill waits for: the page's OWN blend switcher leaving the
    // viewport. The floating one exists to replace it, so it should arrive at
    // the moment the real one goes and not a scroll-length either side of it.
    //
    // This watched the first section instead, which is only the same thing
    // when the switcher happens to sit at the bottom of it. In a tall hero the
    // switcher can leave the viewport long before the section does, and the
    // page then has no blend control at all for the gap between the two.
    //
    // The header cannot be the target: it is sticky, so it never leaves the
    // viewport, never stops intersecting, and the pill would never appear.
    //
    // Scoped to main, which excludes both the header's own switcher and this
    // pill — neither is inside it. Pages with no switcher fall back to the
    // first section, which is the old behaviour and still the right default
    // for them.
    //
    // A panel can say what it is waiting for. The pill replaces the switcher
    // so it waits for the switcher; a reserve button replaces nothing and is
    // simply not wanted on top of the hero, so it waits for the first section.
    // Asking the reserve button to wait for a switcher would have held it back
    // until whichever band happens to contain one had gone by.
    var main = document.getElementById('MainContent') || document.querySelector('main');
    var after = panel.getAttribute('data-float-after') || 'switcher';
    var target = null;
    if (main && after === 'switcher') target = main.querySelector('.bw-blend');
    if (!target && main) target = main.querySelector('.shopify-section');
    if (!target) target = document.querySelector('[data-bw-header]');
    if (!target) return;

    function show(on) {
      panel.classList.toggle('is-visible', on);
      if (on) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');

      /* A panel is visibility:hidden until this runs, and nothing else tells
         a liquid button that it has stopped being hidden: the panel is fixed
         to the bottom of the viewport, so its box always intersects and the
         pour's own IntersectionObserver fires once, at mount, while it is
         still invisible. Announced rather than reached into, because the pool
         belongs to assets/bw-liquid-btn.js and this is a class away from it.

         After the class, not before: the listener reads computed visibility. */
      document.dispatchEvent(new CustomEvent('bw:reveal', { detail: { panel: panel, shown: on } }));
    }

    var obs = new IntersectionObserver(function (entries) {
      show(!entries[0].isIntersecting);
    }, { threshold: 0 });

    obs.observe(target);
    floatObservers.push(obs);
  }

  /* ---- the floating furniture gets out of the way while you move -------- */
  /* Anything pinned to the bottom of the viewport is in the way of the thing
     it is pinned over the moment you start reading past it. So it leaves while
     the page is moving and comes back when it stops.

     Capture phase and one listener, for the reason the sticky header documents
     below: above 990px base.css makes .page-wrapper the scroller and the
     window never scrolls, so a window listener would fire on phones only.
     Scroll does not bubble but it is still dispatched down the capture path.

     A class on <html> rather than a class per panel: the panels are rendered
     by different files — the pill by this section, the reserve button by a
     snippet in the layout — and neither should have to know the other exists.
     Anything that wants the behaviour reads one flag.

     The add is guarded because scroll fires many times a frame and an
     unconditional classList.add on a class already present is still a style
     invalidation. The timer is not throttled: clearTimeout/setTimeout on the
     same handle is cheap, and it is what makes "0.75s after the LAST scroll"
     true rather than "0.75s after the first". */
  var idleTimer = null;
  var IDLE_MS = 750;

  /* ---- a blend change is not the reader scrolling ----------------------- */
  /* Choosing a blend changes how tall the page is — the Daily System says
     more than either sachet on its own, and several bands below the fold
     grow with it. The browser keeps what you are looking at where it is by
     moving the scroll position to match, which is the right thing for it to
     do and completely invisible: nothing on screen shifts.

     It still dispatches a scroll event. Read literally, the page has just
     jumped five hundred pixels, so the furniture got out of the way of a
     reader who had not moved — and the pill ducked off the bottom of the
     screen the instant it was pressed, which reads as the control breaking
     rather than as it being polite.

     So a scroll arriving in the moment after a blend change is ignored. The
     window is short because the re-anchor lands in the same frame as the
     layout it corrects; anything later than that really is the reader. Only
     new scrolls are ignored — a swipe already in progress keeps its class and
     its timer, so this cannot pin the furniture up over a moving page. */
  var SETTLE_MS = 300;
  var settleUntil = 0;

  document.addEventListener('bw:blendchange', function () {
    settleUntil = Date.now() + SETTLE_MS;
  });

  function bindScrollIdle() {
    var root = document.documentElement;
    document.addEventListener('scroll', function () {
      if (Date.now() < settleUntil) return;
      if (!root.classList.contains('bw-scrolling')) root.classList.add('bw-scrolling');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        root.classList.remove('bw-scrolling');
      }, IDLE_MS);
    }, { capture: true, passive: true });
  }

  /* ---- sticky header behaviour ----------------------------------------- */
  /* Direction needs a scroll POSITION, so unlike the observers above this
     cannot be an IntersectionObserver — which brings back the problem they
     exist to avoid: over 990px base.css makes .page-wrapper the scroller and
     window never scrolls, so a window listener would fire on mobile only.

     Bound on document in the CAPTURE phase instead. Scroll does not bubble,
     but it is still dispatched down the capture path, so one listener sees
     both the window and any element scroller, and e.target says which. */
  var lastScrollY = null;
  var scrollTicking = false;

  function scrollTopOf(node) {
    if (!node || node === document || node === document.documentElement || node === window) {
      return window.scrollY || document.documentElement.scrollTop || 0;
    }
    return node.scrollTop || 0;
  }

  function bindScrollUp() {
    var header = document.querySelector('[data-bw-header]');
    var group = document.getElementById('header-group');
    if (!header || !group) return;
    if (!header.classList.contains('is-sticky')) return;

    var scrollUp = header.getAttribute('data-sticky-mode') === 'scroll-up';

    /* How far up the group has to move to clear the viewport. Measured rather
       than assumed: it is the announcement bar plus the header, and the bar is
       optional and its copy can wrap. */
    function measure() {
      group.style.setProperty('--bw-header-group-h', group.offsetHeight + 'px');
    }
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(group);
    else window.addEventListener('resize', measure);

    /* Above the fold the header always shows: nothing to reclaim up there, and
       one that vanishes on the first flick reads as a fault. */
    var TOP = 80;
    /* Sub-pixel drift and rubber-band overscroll both report as movement.
       Without a floor the header flickers while the page is effectively still. */
    var DELTA = 6;

    document.addEventListener('scroll', function (e) {
      if (scrollTicking) return;
      scrollTicking = true;
      var node = e.target;

      requestAnimationFrame(function () {
        scrollTicking = false;

        var y = scrollTopOf(node);

        /* is-stuck used to come from an IntersectionObserver on a sentinel
           rendered just above the header. That sentinel is inside the sticky
           group now, so it never leaves the viewport and never fires. Scroll
           position answers the same question directly. */
        header.classList.toggle('is-stuck', y > 4);

        /* The same re-anchor the idle timer ignores above. Direction is the
           whole judgement here, and a jump the reader did not make has no
           direction worth acting on. The position it lands at is real, so it
           is recorded rather than dropped — without that, the next genuine
           scroll would measure its delta from where the page used to be and
           tuck the header away on a flick upwards. */
        if (Date.now() < settleUntil) { lastScrollY = y; return; }

        if (!scrollUp) { lastScrollY = y; return; }
        if (lastScrollY === null) { lastScrollY = y; return; }

        /* Never hidden while the menu is open — it lives inside the group. */
        var drawerOpen = !!header.querySelector('.bw-drawer.is-open');

        if (y <= TOP || drawerOpen) {
          group.classList.remove('is-headroom-hidden');
          lastScrollY = y;
          return;
        }

        var dy = y - lastScrollY;
        if (Math.abs(dy) < DELTA) return;   // keep lastScrollY, accumulate

        group.classList.toggle('is-headroom-hidden', dy > 0);
        lastScrollY = y;
      });
    }, true);
  }

  var stuckObserver;

  function bindStuck() {
    var sentinel = document.querySelector('[data-bw-header-sentinel]');
    var header = document.querySelector('[data-bw-header]');
    if (!sentinel || !header || stuckObserver) return;

    // Same reasoning as the float observer above: above 990px base.css makes
    // .page-wrapper the scroller and the window never scrolls, so a scroll
    // listener would fire on mobile only. One observer covers both.
    stuckObserver = new IntersectionObserver(function (entries) {
      header.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0 });

    stuckObserver.observe(sentinel);
  }

  function init() {
    sync();
    bindStuck();
    document.querySelectorAll('[data-bw-header]').forEach(bindDrawer);
    bindFloat();
    bindScrollUp();
    bindScrollIdle();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target.querySelector('[data-bw-header]');
    if (h) { bindDrawer(h); bindFloat(); stuckObserver = null; bindStuck(); sync(); }
  });
})();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-hero-split"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. Without this guard
   every save registers another full set of document listeners, and after a
   handful of saves a single click runs dozens of stale handlers holding
   detached nodes — which is what locks the editor tab up. */
if (!window.__bwHeroBound) {
  window.__bwHeroBound = true;

(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bind(root) {
    if (!root || root.dataset.bwParallax !== 'true' || reduce.matches) return;
    var drifts = root.querySelectorAll('[data-bw-drift]');
    if (!drifts.length) return;

    var live = false, frame = 0;

    var io = new IntersectionObserver(function (entries) {
      live = entries[0].isIntersecting;
      if (live) read();
    }, { threshold: 0 });
    io.observe(root);

    function read() {
      frame = 0;
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      root.style.setProperty('--bwf-p', ((vh / 2 - (r.top + r.height / 2)) / vh).toFixed(4));
    }

    function onScroll() { if (live && !frame) frame = requestAnimationFrame(read); }

    read();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function init() { document.querySelectorAll('[data-bw-hero]').forEach(bind); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    bind(e.target.querySelector('[data-bw-hero]'));
  });
})();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-marquee"] && !Shopify.designMode) return;
  try {
    
/* Shopify concatenates every section script into a single bundle, and the
   theme editor re-executes that bundle on each save. Without this guard
   every save registers another full set of document listeners, and after a
   handful of saves a single click runs dozens of stale handlers holding
   detached nodes — which is what locks the editor tab up. */
if (!window.__bwMarqueeBound) {
  window.__bwMarqueeBound = true;

(function () {
  function measure(el) {
    var track = el.querySelector('[data-bw-track]');
    if (!track) return;

    var groups = track.querySelectorAll('[data-bw-group]');
    if (!groups.length) return;

    var one = groups[0];
    var w = one.getBoundingClientRect().width;
    if (!w) return;

    /* Clone until the track spans at least twice the viewport, so a short
       phrase list cannot leave a visible gap on a wide screen. */
    var need = Math.max(2, Math.ceil((el.getBoundingClientRect().width * 2) / w));
    var have = groups.length;
    for (var i = have; i < need; i++) {
      var clone = one.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    var speed = parseFloat(el.dataset.speed) || 70;
    el.style.setProperty('--bwm-shift', w + 'px');
    el.style.setProperty('--bwm-dur', (w / speed).toFixed(2) + 's');
  }

  function all() { document.querySelectorAll('[data-bw-marquee]').forEach(measure); }

  function init() {
    all();
    /* Fonts change metrics: Plakette is font-display:block, so a measurement
       taken before it lands would be wrong by a wide margin. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(all, 200);
    });

    /* Restore copy can be a different length, so re-measure on blend change. */
    document.addEventListener('bw:blendchange', function () { setTimeout(all, 50); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    var m = e.target.querySelector('[data-bw-marquee]');
    if (m) measure(m);
  });
})();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
